import { useState } from "react";
import { useFacturas } from "../../../contexto/provider/FacturasContext.js";

// componentes UI
import PopupInferior from "../../../componentsUI/estructura/modal/popup/popup.js";
import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import FacturaCard from "../tarjetaFacturas/FacturaCard.js";

import "./facturasGrid.css";

export default function FacturasGrid() {
  const {
    facturas,
    totalFacturas,
    pagarFactura,
    cancelarFactura,
  } = useFacturas();

  const [facturaAbierta, setFacturaAbierta] = useState(null);
  const [metodosPago, setMetodosPago] = useState({});
  const [mensajePopup, setMensajePopup] = useState(null);

  // PAGAR
  const onPagar = async (factura) => {
    const metodo = metodosPago[factura.numeroFactura];

    if (!metodo) {
      alert("Selecciona método de pago");
      return;
    }

    try {
      await pagarFactura(factura, metodo);

      // limpia método local
      setMetodosPago((prev) => {
        const copia = { ...prev };
        delete copia[factura.numeroFactura];
        return copia;
      });

      setFacturaAbierta(null);
      setMensajePopup("Pago registrado correctamente ✅");
    } catch (e) {
      console.error("Error al registrar el pago:", e);
      alert(e?.message || "Error al registrar el pago");
    }
  };

  // CANCELAR
  const onCancelar = async (factura) => {
    const confirmar = window.confirm(
      `¿Seguro que deseas cancelar la factura ${factura.numeroFactura}?`,
    );

    if (!confirmar) return;

    try {
      await cancelarFactura(factura);

      // limpia método local si existía
      setMetodosPago((prev) => {
        const copia = { ...prev };
        delete copia[factura.numeroFactura];
        return copia;
      });

      setFacturaAbierta(null);
      setMensajePopup("Factura cancelada correctamente ❌");
    } catch (e) {
      console.error("Error al cancelar la factura:", e);
      alert(e?.message || "Error al cancelar la factura");
    }
  };

  return (
    <div>
      <TituloModulo titulo="Facturas pagos pendientes" />

      <div className="contenedor-facturasgrid">
        <div className="facturas-total">
          Total general: ${totalFacturas.toLocaleString()}
        </div>

        {facturas.map((factura) => (
          <FacturaCard
            key={factura.numeroFactura}
            factura={factura}
            abierta={facturaAbierta === factura.numeroFactura}
            metodoPago={metodosPago[factura.numeroFactura]}
            onToggle={() =>
              setFacturaAbierta(
                facturaAbierta === factura.numeroFactura
                  ? null
                  : factura.numeroFactura,
              )
            }
            onMetodoPago={(m) =>
              setMetodosPago((prev) => ({
                ...prev,
                [factura.numeroFactura]: m,
              }))
            }
            onPagar={() => onPagar(factura)}
            onCancelar={() => onCancelar(factura)}
          />
        ))}

        <PopupInferior
          mensaje={mensajePopup}
          visible={!!mensajePopup}
          onClose={() => setMensajePopup(null)}
        />
      </div>
    </div>
  );
}
